export default "__VITE_ASSET__D3za_qG6__"